module.exports = __webpack_public_path__ + "img/rosepetal-dep-aisvision.192b436c.jpg";